import { apiClient as liveApiClient } from "@/app/api/live";

export default liveApiClient;
